import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'corner-left-down-double',
  'IconCornerLeftDownDouble',
  [
    ['path', { d: 'M18 4h-6a3 3 0 0 0 -3 3v7', key: 'svg-0' }],
    ['path', { d: 'M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4', key: 'svg-1' }],
  ],
);
